module.exports = __webpack_public_path__ + "img/1445369394.a064738e.jpg";